<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapter">4</h1>
<h1 class="chapter1">ALDER AS ‘EBONY’</h1>
<p class="indent">Immersion in a peat bog for a considerable time turns most timber to a very dark colour; and it is really marvellous how it—instead of rotting—hardens and preserves wood. This is probably not the case with some timbers, but it is so with elm and oak. We have seen a number of polished specimens of wood recovered from Irish bogs. Oak especially is susceptible of much darkening by bog immersion.</p>
<p class="indent">In the case of alder, however, the effect of this immersion is to turn the wood so black that it passes a cursory examination as ebony. It lacks, however, the gloss of ebony, the result being a dull instead of a shining black; so that it would not deceive an expert in woods. The difficulty of exact imitation is nearly surmounted by using a dye of a very deep black and polishing the surface. It has not even then quite the brilliancy of real ebony.</p>
<p class="indent">The great botanist Linnaeus was, we believe, the first to observe that the tongues of horses which fed in the summer on alder leaves turned black.</p>
<p class="indent">The natural habitat of the alder is on the banks of streams, and perpetual exposure to excessive damp prepares it naturally for use as timber in damp positions. Hence alder wood is especially valuable because of its durability and damp-proof capacity for all positions in water, such as the piles of bridges, wooden posts of all kinds required to remain for many years in the earth, as well as for many other purposes requiring wood of a durable substance.</p>
<p class="indent">There is especial value in the roots of large old alder-trees, because they are full of knots that, when polished, are considered to compare favourably with the beauty of what is called ‘curled maple.’ The wood is of a rich, reddish tint, and is made into beautiful and valuable tables.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c04.vue?fae5d7a4